module.exports = __webpack_public_path__ + "media/images/mbdr-d971b719669c759c85bfdfe33ff9cded.jpg";